import uniq from 'lodash.uniq';
import * as React from 'react';
import { trackView } from '../../services/analytics';
import { companies } from './OurCompaniesData';
import Render from './render';

class OurCompaniesPage extends React.Component<any> {
  state = {
    filterActiveIndex: 0,
    filteredCompanies: companies,
  };

  get navItems() {
    return ['All'].concat(uniq(companies.map(company => company.company)));
  }

  filterCompanies = (companyName: string, index: number) => (e: Event) => {
    const filtered = this.getFilteredCompanies(companyName);
    const all = companies;
    const companiesFiltered = companyName === 'All' ? all : filtered;

    this.setState(() => ({
      filterActiveIndex: index,
      filteredCompanies: companiesFiltered
    }));
  }

  getFilteredCompanies(companyName: string) {
    return companies.filter((company) => company.company === companyName);
  }

  componentDidMount() {
    trackView(this.props.location.pathname);
  }

  render() {
    return Render.call(this, this.props, this.state);
  }
}

export default OurCompaniesPage;



// WEBPACK FOOTER //
// ./src/containers/OurCompanies/index.tsx